import axios from 'axios'

const ENDPOINT = 'process'

export default {
  getTree: async sitePath => {
    const url = `${sitePath}/${ENDPOINT}/tree/`
    const response = await axios.get(url)

    return response.data
  },
}
